import PropTypes from 'prop-types';
// material
import { Box } from '@material-ui/core';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  return (
    <Box
      component="img"
      src="/images/incorta-logo.png"
      sx={{ width: 40, height: 40, borderRadius: '5px', ...sx }}
    />
  );
}
